import { ICostCode } from 'redux-store/api/selections';

export const getCostCodeOptionLabel = ({
  categoryNumber,
  costCodeNumber,
  costCodeName,
}: {
  categoryNumber: ICostCode['category']['number'];
  costCodeNumber: ICostCode['number'];
  costCodeName: ICostCode['name'];
}): string => `${categoryNumber} - ${costCodeNumber} - ${costCodeName}`;
